export const GENERIC_DIAL_FAILURE = 'The call could not be started.';

const BY_CODE: Record<number, string> = {
  31000: 'The softphone lost its connection. Try again.',
  31005: 'The softphone lost its connection. Try again.',
  31009: 'The softphone lost its connection. Try again.',
  31201: 'The microphone could not be used. Check its permission and try again.',
  31208: 'The microphone permission was declined. Allow it and try again.',
  31402: 'The microphone could not be used. Check its permission and try again.',
  31003: 'The call could not connect. Check the network and try again.',
  31205: 'The softphone session expired. Try again.',
};

const NOT_READY = 'The softphone is still starting up. Try again in a moment.';

export const extractTwilioCode = (raw: string | undefined): number | undefined => {
  if (raw === undefined) return undefined;
  const match = /\b(3\d{4})\b/.exec(raw);
  if (!match) return undefined;
  return Number(match[1]);
};

export const dialFailureText = (input: {
  code?: number;
  message?: string;
}): string => {
  const code = input.code ?? extractTwilioCode(input.message);
  if (code !== undefined && BY_CODE[code] !== undefined) {
    return BY_CODE[code];
  }
  if (input.message !== undefined && /not ready yet/i.test(input.message)) {
    return NOT_READY;
  }
  return GENERIC_DIAL_FAILURE;
};
